import { IRouteConfig } from 'helpers/route-config';
import {
    fatigueAssessmentRoute,
    fatigueAssessmentBlankFormRoute,
    fatigueAssessmentFormRoute,
    fatigueAssessmentOnBehalfRoute,
    fatigueAssessmentAssignRoute,
    fatigueAssessmentDashboardPathRoute,
    fatigueAssessmentPendingPathRoute,
    fatigueAssessmentActionPathRoute,
    fatigueAssessmentRevisitPathRoute,
    fatigueAssessmentCompletedPathRoute,
    fatigueAssessmentDetailsPathRoute,
    fatigueAssessmentOverviewPathRoute
} from "components/portal/fatigueAssessment/FatigueAssessmentRoutes";

export const fatigueAssessmentFormUrl = (id: number) => {
    if (typeof (fatigueAssessmentFormRoute?.path) === 'string') {
        return fatigueAssessmentFormRoute.path.replace(':id', id.toString());
    }
    return '';
};

export const allFatigueAssessmentRoutes = (): any[] => {
    const routes = [
        fatigueAssessmentRoute,
        fatigueAssessmentBlankFormRoute,
        fatigueAssessmentFormRoute,
        fatigueAssessmentOnBehalfRoute,
        fatigueAssessmentAssignRoute,
        fatigueAssessmentDashboardPathRoute,
        fatigueAssessmentPendingPathRoute,
        fatigueAssessmentActionPathRoute,
        fatigueAssessmentRevisitPathRoute,
        fatigueAssessmentCompletedPathRoute,
        fatigueAssessmentDetailsPathRoute,
        fatigueAssessmentOverviewPathRoute
    ];
    return routes;
};
